import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './components/App';
import { LanguageProvider } from './contexts/LanguageContext';
// Create a responsive theme
var theme = createTheme({
    palette: {
        primary: {
            main: '#3f51b5', // Indigo
        },
        secondary: {
            main: '#f50057', // Pink
        },
        background: {
            default: '#f5f5f5',
        },
    },
    typography: {
        fontFamily: [
            'Roboto',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                    padding: '10px 24px',
                },
                containedPrimary: {
                    boxShadow: '0 2px 10px rgba(63, 81, 181, 0.3)',
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    paddingTop: 16,
                    paddingBottom: 16,
                },
            },
        },
    },
});
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(LanguageProvider, { children: _jsx(App, {}) })] }) }));
